import styled, { css } from 'styled-components'
import { SecondaryButtonLink } from '@chegg-ui/button-link'
import { colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import { SecondaryButton } from '@chegg-ui/button'
import { ShimmerTitleText } from '@chegg-ui/shimmer'
import { LEFT_PANEL_WIDTH } from '../Layout/styled'

const paperCheckInProgressStyles = (isPaperCheckInProgress: boolean) =>
  isPaperCheckInProgress &&
  css`
    cursor: default;
    background-color: ${colors.grey050};
  `

export const ProofreaderLeftPanelContainer = styled.div`
  max-width: ${LEFT_PANEL_WIDTH}px;
  padding: ${spacing.px24} ${spacing.px16};
  border-right: 1px solid ${colors.grey100};
  padding: ${spacing.px24} 0;
`

const menuItemStyles = css`
  color: ${colors.grey800};
  font-size: ${font.size.px16};
  margin-bottom: ${spacing.px8};
  padding: ${spacing.px12} ${spacing.px16};
  &.active,
  &:hover {
    background-color: ${colors.transparent};
    color: ${colors.grey800};
  }
`

type MenuItemProps = { isActive?: boolean }

export const MenuItem = styled(SecondaryButtonLink).attrs({
  variant: 'text',
  size: 'xlarge',
})<MenuItemProps>`
  && {
    ${menuItemStyles}

    font-weight: ${font.weight.medium};
    text-decoration: none;
  }
`
export const WritingAssistantMenuItem = styled(SecondaryButton).attrs({
  variant: 'text',
  size: 'xlarge',
})`
  && {
    ${menuItemStyles}

    .chevron {
      width: 16px;
      height: 16px;
      min-width: 16px;
      min-height: 16px;
    }
  }
`

export const WritingItemContainer = styled.div`
  display: flex;
  align-items: baseline;
`

export const BetaReleaseContainer = styled.div`
  display: flex;
  padding: 1px ${spacing.px8} 1px ${spacing.px8};
  justify-content: center;
  border: 1.5px solid ${colors.grey900};
  border-radius: ${spacing.px4};
  align-items: center;
  margin: ${spacing.px8} 0 ${spacing.px8} ${spacing.px8};
`

export const BetaReleaseText = styled(Typography).attrs({
  variant: 'body2',
  variantType: 'bold',
})`
  color: ${colors.grey900};
`

export const PaperList = styled.ul`
  max-height: 372px;
  overflow: auto;
`

const listItemStyles = css`
  padding: ${spacing.px8};
  cursor: pointer;
  white-space: nowrap;
  border-radius: 6px;
  margin: ${spacing.px4} ${spacing.px8};

  &:hover,
  &:active {
    background-color: ${colors.grey100};
  }
`
export const TooltipText = styled.span`
  line-height: ${font.lineHeight.sm};
  font-size: ${font.size.px12};
  font-weight: ${font.weight.normal};
  white-space: initial;
`
const listTitleStyles = css`
  width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${font.size.px14};
  line-height: ${font.lineHeight.md};
  color: ${colors.grey800};
`

export const NewDocumentButtonTitle = styled.div`
  ${listTitleStyles};
`

export const ListItemPaperTitle = styled.span`
  ${listTitleStyles};

  & + [role='tooltip'] {
    max-width: 95%;
  }
`

const listSubtitleStyles = css`
  font-size: ${font.size.px12};
  line-height: ${font.lineHeight.md};
  color: ${colors.grey500};
`

export const NewDocumentButtonSubtitle = styled.div`
  ${listSubtitleStyles};
`

export const ListItemPaperStatus = styled.div`
  ${listSubtitleStyles};
  display: none;
`

export const ShimmerListItem = styled(ShimmerTitleText)`
  width: 90%;
  height: 16px;

  & + & {
    width: 100%;
    margin-top: ${spacing.px4};
  }
`

type ListItemProps = {
  isPaperCheckInProgress?: boolean
  isActive?: boolean
}

export const ListItem = styled.li<ListItemProps>`
  ${listItemStyles}

  ${({ isActive = false }) =>
    isActive &&
    css`
      background-color: ${colors.grey100};
      ${ListItemPaperTitle} {
        font-weight: ${font.weight.bold};
      }
      ${ListItemPaperStatus} {
        color: ${colors.grey800};
      }
    `}

    &:has(${ShimmerListItem}) {
    padding: ${spacing.px4} ${spacing.px8};
  }

  ${({ isPaperCheckInProgress }) => paperCheckInProgressStyles(isPaperCheckInProgress)}
`

export const ItemContainer = styled.div`
  > span:first-child {
    width: 100%;
  }
`

export const NewDocButtonContainer = styled.li<{
  isPaperCheckInProgress: boolean
}>`
  ${listItemStyles}
  display: flex;
  align-items: center;

  > div:first-child {
    flex: 1;
  }
  ${({ isPaperCheckInProgress }) => paperCheckInProgressStyles(isPaperCheckInProgress)}
`
